import { schemaDadosPessoais } from './FormDadosPessoais.jsx';
import { criarSchemaSocioEconomicos } from './FormSocioEconomicos.jsx';
import { criarSchemaDadosInscricao } from './FormDadosInscricao.jsx';
import { criarSchemaDocumentos } from './FormDocumentos.jsx';
import { schemaFinalizar } from './FormFinalizar.jsx';
import { STEP_IDS } from './inscricaoSections';

/*
 * Schema Yup de uma etapa macro, montado a partir do mesmo contexto que o
 * formulário da etapa usaria. Permite validar uma etapa que não está montada —
 * é o que sustenta o pulo direto para uma etapa já alcançada no mobile.
 */
export function getSchemaEtapa(stepId, { formulario = {}, inscricao = {} } = {}) {
    switch (stepId) {
        case STEP_IDS.DADOS_PESSOAIS:
            return schemaDadosPessoais;
        case STEP_IDS.SOCIOECONOMICO:
            return criarSchemaSocioEconomicos(formulario);
        case STEP_IDS.DADOS_INSCRICAO:
            return criarSchemaDadosInscricao(formulario);
        case STEP_IDS.DOCUMENTOS:
            return criarSchemaDocumentos(
                inscricao.documentosExigidos || [],
                inscricao.permitirEntregaDocumentos ?? false
            );
        case STEP_IDS.FINALIZAR:
            return schemaFinalizar;
        default:
            return null;
    }
}
